var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 183.63,
    height: 226.994,
    viewBox: "0 0 183.63 226.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete",
    transform: "translate(-7913.173 -10541.994)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4433",
    "data-name": "Path 4433",
    d: "M333.866,63.486H280.923V51.443A13.456,13.456,0,0,0,267.486,38H226.832a13.456,13.456,0,0,0-13.438,13.443V63.491H160.452a5.116,5.116,0,0,0-5.109,5.109V84.334a5.119,5.119,0,0,0,5.109,5.109H333.863a5.119,5.119,0,0,0,5.109-5.109V68.595a5.119,5.119,0,0,0-5.109-5.109ZM220.8,51.443a6.043,6.043,0,0,1,6.034-6.034h40.654a6.043,6.043,0,0,1,6.034,6.034V63.491H220.8Z",
    transform: "translate(7757.831 10503.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4434",
    "data-name": "Path 4434",
    d: "M193.6,321.522a5.558,5.558,0,0,0,5.555,5.217h125.11a5.557,5.557,0,0,0,5.555-5.217L340.533,154.87H182.871ZM296.2,188.5a1.941,1.941,0,0,1,1.927-1.813,1.879,1.879,0,0,1,1.776,1.924l-3.442,86.743a1.848,1.848,0,0,1-1.854,1.78h-.075a1.864,1.864,0,0,1-1.774-1.929Zm-36.357.037a1.857,1.857,0,0,1,3.715,0v86.743a1.857,1.857,0,0,1-3.715,0Zm-34.579-1.85h0A1.942,1.942,0,0,1,227.2,188.5l3.442,86.706v0a1.864,1.864,0,0,1-1.774,1.929h-.075a1.848,1.848,0,0,1-1.854-1.78l-3.442-86.743a1.879,1.879,0,0,1,1.776-1.924Z",
    transform: "translate(7743.284 10442.25)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.310ff3682cb5c23671c89f386659ed4e.svg";
export { ForwardRef as ReactComponent };